import {
  getDataFromServer,
  postDataToServer,
  postDataToServerWithFullResponse,
  putDataToServer
} from '../../../util';

/**
 * TestScenarioDashboard
 */
export class TestScenarioDashboard {
  constructor(baseURL, tmURL, httpHeaders) {
    this.baseURL = baseURL;
    this.tmURL = tmURL;
    this.httpHeaders = httpHeaders;
  }

  // Create Run Instance APIs
  saveTypologySegments = async (payload) => {
    const { id = '', data = '' } = payload || {};
    let url = `${this.tmURL}/scenarios/${id}/typologies/configureSegments`;
    const response = await postDataToServerWithFullResponse(url, data);
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(
        response?.data?.message || 'Failed to save the configuration'
      );
    } else {
      return response.data || 'Success';
    }
  };

  getScenarioTypologies = async (payload = {}) => {
    const { id } = payload;
    let url = `${this.baseURL}/scenarios/${id}/typologies`;
    return await getDataFromServer(url, this.httpHeaders);
  };

  // create run instance APIs END

  // Create Scenario APIs

  /**
   * createScenario
   * @param payload
   * @returns {Promise<unknown>}
   */
  createScenario = async (payload) => {
    const { name, sourceId } = payload;
    const data = {
      name,
      sourceId
    };
    let url = `${this.baseURL}/scenarios`;
    return await postDataToServer(url, data);
  };

  /**
   * deleteScenario
   * @param payload
   * @returns {Promise<any>}
   */
  deleteScenario = async (payload) => {
    const params = {};
    const response = await putDataToServer(url, this.httpHeaders, params);
    if (response.status !== 200 && response.status !== 202) {
      throw Error(response.data.message);
    } else {
      return response.data;
    }
  };

  /**
   * cloneScenario
   * @param payload
   * @returns {Promise<any>}
   */
  cloneScenario = async (payload) => {
    const { originalId = '', name = '', sourceId = '' } = payload || {};
    const params = {
      originalId,
      name,
      sourceId
    };
    let url = `${this.baseURL}/scenarios`;
    return await postDataToServer(url, params).then(async (data) => {
      if (data && data.message) {
        throw { message: data.message };
      }
      return await this.getAllScenarios({});
    });
  };

  /**
   * updateScenario
   * @param payload
   * @returns {Promise<any>}
   */
  updateScenario = async (payload) => {
    const params = {};
    const response = await putDataToServer(url, this.httpHeaders, params);
    if (response.status !== 200 && response.status !== 202) {
      throw Error(response.data.message);
    } else {
      return response.data;
    }
  };

  /**
   * addMappingToScenario
   * @param payload
   * @returns {Promise<*>}
   */
  addMappingToScenario = async (payload) => {
    const { typologyIds, scenarioIds } = payload;
    const params = {
      scenarioIds,
      typologyIds
    };
    const url = `${this.baseURL}/scenarios/typologies`;
    const response = await postDataToServer(url, params);
    if (response.status !== 200 && response.status !== 202) {
      throw Error(response.data.message);
    } else {
      return response.data;
    }
  };

  /**
   * getAllScenarios
   * @param payload
   * @returns {Promise<unknown>}
   */
  getAllScenarios = async (payload = {}) => {
    const { page, pageSize, sourceId } = payload;
    const params =
      page && pageSize
        ? { limit: pageSize, offset: (page - 1) * pageSize, sourceId: sourceId }
        : { sourceId };
    let url = `${this.baseURL}/scenarios`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  /**
   * getSingleScenarioDetails
   * @param payload
   * @returns {Promise<*>}
   */
  getSingleScenarioDetails = async (payload) => {
    const { scenarioID, sourceId } = payload;
    let url = `${this.baseURL}/scenarios/${scenarioID}`;
    const params = { sourceId };
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  /**
   * triggerScenario
   * @param payload
   * @returns {Promise<unknown>}
   */
  triggerScenario = async (payload) => {
    const { scenarioID, pipelineId, training, prediction } = payload;
    const url = `${this.baseURL}/scenarios/${scenarioID}/execute`;
    const data = await postDataToServer(url, {
      pipelineId: pipelineId,
      training,
      prediction
    });
    if (data) {
      return data;
    } else {
      return [];
    }
  };

  /**
   * getRunInstanceHistory
   * @param payload
   * @returns {Promise<unknown>}
   */
  getRunInstanceHistory = async (payload) => {
    const { page = 1, pageSize = 10, scenarioID } = payload;
    const url = `${this.baseURL}/scenarios/${scenarioID}/instances`;
    const params = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    };
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (data) {
      return data;
    } else {
      return [];
    }
  };
}
